import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormField } from '../../core/models/form';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormService {

   createForm(form: { [key: string]: FormField }): FormGroup {
      const formBuilder = new FormBuilder();
      const formControls: { [key: string]: FormControl } = {};
  
      Object.keys(form).forEach(key => {
        const field = form[key];
        formControls[key] = new FormControl(field.value, field.validators);
      });
  
      return formBuilder.group(formControls);
    }

    //   getFormField(form: { [key: string]: FormField }): Observable<any> {
    //     return of(form);
    //   }
}
